<template>
  <TableGradient
      icon-name="compress"
      :title="$t('tuevs.method.listagem.titulo_pagina')"
      :items="methods"
      table-data
      :fields="fields"
      :loading="isLoading"
      :paginator="pagination"
      :text-empty="$t('tuevs.method.listagem.table.empty')"
      route-new="tuevs.method.create"
      :text-new="$t('tuevs.method.listagem.novo')"
      @list="evt => $store.dispatch('tuevs/method/listAll', evt)">
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.method.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.method.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.method.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.method.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/method/isLoading',
      methods: 'tuevs/method/all',
      pagination: 'tuevs/method/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.method.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.method.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.method.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/method/listAll'
    ])
  },
  mounted() {
    this['tuevs/method/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
.badge-danger {
  background-color: #ffe1de;
  color: #e74a3b;
}

.badge-success {
  background-color: #d8fbee;
  color: #1cc88a;
}
</style>
